import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getResidueTypeList as getResidueTypeListApi,
	getResidueType as getResidueTypeApi,
	addNewResidueType as addNewResidueTypeApi,
	updateResidueType as updateResidueTypeApi,
	deleteResidueType as deleteResidueTypeApi,
} from '../../helpers/residue/backend_helper';

export const getResidueTypeList = createAsyncThunk('residueTypes/getResidueTypeList', async () => {
	try {
		const response = getResidueTypeListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getResidueType = createAsyncThunk('residueTypes/getResidueType', async residueType_id => {
	try {
		const response = getResidueTypeApi(residueType_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewResidueType = createAsyncThunk('residueTypes/addNewResidueType', async residueType => {
	try {
		const response = addNewResidueTypeApi(residueType);
		toast.success('ResidueType agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar residueType.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateResidueType = createAsyncThunk('residueTypes/updateResidueType', async (residueType) => {
		try {
			const response = updateResidueTypeApi(residueType);
			toast.success('ResidueType actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar residueType.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteResidueType = createAsyncThunk('residueTypes/deleteResidueType', async residueType => {
	try {
		const response = await deleteResidueTypeApi(residueType);
		toast.success('ResidueType eliminado exitosamente.', { autoClose: 3000 });
		return { residueType, ...response };
	} catch (error) {
		toast.error('Error al eliminar residueType.', { autoClose: 3000 });
		throw new Error(error);
	}
});
